import LinkButton from '~/components/button/LinkButton';
import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Field from '~/components/form-controls/Field';
import Page from '~/components/layout/page/Page';
import { useActionResult, useLoaderData } from './reasonFollowUp';

const defaultMessage =
  "Sorry, but it looks like this item isn't eligible for return. If you have any questions, please contact us.";

export default function ReasonFollowUpPage() {
  const { reasonPolicy, orderId, store, claimType } = useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Section>
      {!actionResult?.ok ? (
        <Form name="claimFollowUp">
          <p className="heading-sm text-on-surface">
            {reasonPolicy.params.question}
          </p>
          {actionResult?.ok === false && (
            <Field.ErrorText>
              Sorry something went wrong. Please try again.
            </Field.ErrorText>
          )}
          <div className="flex flex-col gap-4 sm:flex-row">
            <LinkButton className="flex-1" to="../meta">
              No
            </LinkButton>
            <input
              data-testid="followUpConfirm"
              type="hidden"
              name="followUpConfirm"
              value="true"
            />
            <Submit className="flex-1">Yes</Submit>
          </div>
        </Form>
      ) : (
        <>
          <p className="heading-sm text-on-surface">
            {reasonPolicy.params.onYesMessage ?? defaultMessage}
          </p>
          <LinkButton
            to={`/${store}/order/${orderId}/${claimType.toLowerCase()}`}
          >
            Back to Order
          </LinkButton>
        </>
      )}
    </Page.Section>
  );
}
